import React, { useEffect } from 'react';
import TwAutocomplete, {
  TwAutocompleteOption,
  TwAutocompleteProps
} from '../TwAutocomplete/TwAutocomplete';
import DriverUtils from '../../utils/driver/driverUtils';
import useAuth from '../../providers/Auth/Auth.provider';

type TwDriverPayRateTypeSelectorProps = Omit<TwAutocompleteProps, 'optionList' | 'sortList'>;

const TwDriverPayRateTypeSelector: React.FC<TwDriverPayRateTypeSelectorProps> = ({
  ...props
}): JSX.Element => {
  const {
    data: { userData }
  } = useAuth();

  const [payRateTypes, setPayRateTypes] = React.useState<TwAutocompleteOption[]>([]);

  useEffect(() => {
    const PAY_TYPE_OPTIONS = DriverUtils.payRateTypesToAutocompleteOptions();
    /*  if (!enableLtl) {
      if (PAY_TYPE_OPTIONS.findIndex((option) => option.id === 'PERCENTAGE') === -1) {
        PAY_TYPE_OPTIONS.push({ id: 'PERCENTAGE', label: 'Percentage', value: 'Percentage' });
      }
    } else {
      const index = PAY_TYPE_OPTIONS.findIndex((option) => option.id === 'PERCENTAGE');
      if (index > -1) {
        PAY_TYPE_OPTIONS.splice(index, 1);
      }
    } */

    setPayRateTypes(PAY_TYPE_OPTIONS);
  }, []);

  return (
    <React.Fragment>
      <TwAutocomplete {...props} optionList={payRateTypes} sortList={false} />
    </React.Fragment>
  );
};

export default TwDriverPayRateTypeSelector;
